import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <motion.div 
      className="language-selector"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
    >
      <motion.button 
        onClick={toggleLanguage}
        className={`lang-btn ${language === 'fr' ? 'active' : ''}`}
        whileHover={{ 
          scale: 1.1,
          rotate: 5,
          transition: { duration: 0.2 }
        }}
        whileTap={{ scale: 0.9 }}
        animate={{
          rotate:  0,
          transition: { duration: 0.3 }
        }}
      >
        {language === 'fr' ? 'FR' : 'EN'}
      </motion.button>
    </motion.div>
  );
};

export default LanguageSelector; 